<template>
  <div>
    <el-row class="title-bar" type="flex" justify="space-between">
      <div class="vertical-center-box">
        <div class="title-h3 mr-r15">관리 대상 목록</div>
        <el-button class="mr-r4" type="primary" size="mini" @click="onRegistDeviceButton">수동 등록</el-button>
        <!-- <w-group-save-button class="mr-r4" :disabled="selectedRowArray.length == 0" managetype-id="FMS"
      :rsc-event-rule-list="rscEventRuleList" :event-alarm-rule-list="eventAlarmRuleList" @group-save="groupSave"/> -->
        <el-button class="mr-r15" size="mini" :disabled="selectedRowArray.length === 0" @click="onDelDevice">장비 삭제</el-button>
        <span class="mr-r5">관리여부</span>
        <div class="setting-addel">
          <el-button size="mini" @click="AllCheckChangeButtonClick('1')"><i class="fas fa-check-square"></i></el-button>
          <el-button size="mini" @click="AllCheckChangeButtonClick('0')"><i class="far fa-square"></i></el-button>
        </div>
      </div>
      <div class="vertical-center-box">
        <el-checkbox :checked="beforeThreeDayFlag" v-model="beforeThreeDayFlag" @change="onChangeThreeFlag">
          최근 3일 이내 등록된 장비 <em>{{ recentRegisteredFmsCount }}개</em></el-checkbox
        >
        <el-button class="mr-r4" type="primary" size="mini" @click="onSaveButton" :disabled="!cellEditing.isModified">저장</el-button>
        <el-button class="mr-r4" size="mini" @click="loadData" :disabled="!cellEditing.isModified">취소</el-button>
        <w-header-pagination class="mr-r4" :pagination="pagination" @current-change="handlerHeaderCurrentChange"></w-header-pagination>
        <w-header-search-button size="mini" @click="setSearchToolVisible"></w-header-search-button>
      </div>
    </el-row>
    <el-table-wrapper
      v-loading="isLoading"
      :editable="true"
      :column-default="columnDefault"
      ref="deviceTable"
      @selection-change="changeHandleSelection"
      :data="tableData"
      :columns="tableColumn"
      :pagination="true"
      :show-search-tool="showSearchTool"
      :show-custom-header="true"
      @condition-change="onChangeTable"
      @pagination-change="handlerPaginationChange"
      @total-change="handlerPaginationChange"
      @cell-dblclick="startEdit"
      remote
      :total="total"
    >
      <!-- 관리여부 -->
      <template #switch-slot="scope">
        <w-switch-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" active-value="1" inactive-value="0" @cell-edit-end="editTwoStatusCell" />
      </template>
      <!-- 센서명 -->
      <template #input-slot="scope">
        <w-input-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" @cell-edit-end="endEdit" />
      </template>
      <!-- 센서종류 -->
      <template #seonsor-type-slot="scope">
        <w-select-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" :list="sensorTypeList" keyField="objtypeId" labelField="objtypeName" valueField="objtypeId" @cell-edit-end="endEdit" />
      </template>
      <!-- 수집장비명 -->
      <template #rtu-slot="scope">
        <w-select-editor
          v-if="scope.row.parentObjtypeId === 'RTU'"
          :editing-prop="cellEditing.property"
          :data="scope.row"
          :property="scope.column.property"
          :required="true"
          :list="rtuList"
          keyField="objId"
          labelField="objName"
          valueField="objId"
          @cell-edit-end="rtuEndEdit"
        />
        <span v-else>{{ scope.row.parentObjName }}</span>
      </template>
      <!-- IP주소 -->
      <template #ipaddress-slot="scope">
        <w-input-editor v-if="scope.row.parentObjtypeId !== 'RTU'" :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" :validation="validateIpaddress" @cell-edit-end="endIpaddressEdit" />
        <span v-else>{{ scope.row.ipaddress }}</span>
      </template>
      <!-- SNMP 버전 -->
      <template #snmp-version-slot="scope">
        <w-select-editor
          :editing-prop="cellEditing.property"
          :data="scope.row"
          :property="scope.column.property"
          :required="true"
          :list="snmpVersionList"
          keyField="basicinfoSubid"
          labelField="basicinfoSubname"
          valueField="basicinfoSubid"
          @cell-edit-end="endEdit"
        />
      </template>
      <!-- SNMP 커뮤니티 -->
      <template #community-slot="scope">
        <w-input-editor type="password" :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" @cell-edit-end="endEdit">
          <span slot="content">{{ convertCommunityRead(scope.row) }}</span>
        </w-input-editor>
      </template>
      <!-- SNMP 포트 - 자체수집 -->
      <template #snmp-port-slot="scope">
        <w-number-editor v-if="scope.row.parentObjtypeId !== 'RTU'" :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :min="0" @cell-edit-end="endEdit" />
        <span v-else>{{ portEmptyText(scope.row) }}</span>
      </template>
      <!-- TCP 포트 - RTU -->
      <template #tcp-port-slot="scope">
        <w-number-editor v-if="scope.row.parentObjtypeId === 'RTU'" :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :min="0" @cell-edit-end="endEdit" />
        <span v-else>{{ portEmptyText(scope.row) }}</span>
      </template>
      <!-- 이벤트 제외 -->
      <template #checkbox-slot="scope">
        <w-checkbox-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" true-label="1" false-label="0" @cell-edit-end="editTwoStatusCell" />
      </template>
      <!-- 이벤트/알림정책 -->
      <template #rsc-rule-slot="scope">
        <w-select-editor
          :editing-prop="cellEditing.property"
          :data="scope.row"
          :property="scope.column.property"
          :required="true"
          :list="rscEventRuleList"
          keyField="ruleTmplId"
          labelField="ruleTmplName"
          valueField="ruleTmplId"
          @cell-edit-end="endEdit"
        />
      </template>
      <!-- 장비등록일시 -->
      <template #event-rule-slot="scope">
        <w-select-editor
          :editing-prop="cellEditing.property"
          :data="scope.row"
          :property="scope.column.property"
          :required="true"
          :list="eventAlarmRuleList"
          keyField="ruleTmplId"
          labelField="ruleTmplName"
          valueField="ruleTmplId"
          @cell-edit-end="endEdit"
        />
      </template>
    </el-table-wrapper>
    <w-facility-device-add-popup ref="facilityAddPop" :snmp-version-list="snmpVersionList" :rtu-list="rtuList" :sensor-type-list="sensorTypeList" @load-data="loadData"></w-facility-device-add-popup>
  </div>
</template>

<script>
import { isNil, cloneDeep, isEmpty, find, isEqual } from 'lodash';
import { columnDefault, defaultPagination } from '@/constants/table';
import { EMPTY_TEXT, validateIpv4, validateIpv6 } from '@/utils/string';
import { getDateToString } from '@/utils/date';
import msgUtil from '@/utils/message';
import { getRsaEncryptBulk } from '@/utils/rsa-encrypt';
import { PASSWORD_FOR_VIEW } from '@/constants/common';

import rulApi from '@/api/settings/common/rule';
import BasicinfoSubAPI from '@/api/model/basicinfo-sub';
import DeviceRegistrationFmsApi from '@/api/settings/common/device-registration-fms';
import DeviceRegistrationCommonAPI from '@/api/settings/common/device-registration-common';

import CellEditingMixin from '@/mixins/table/cell-editing';
import WInputEditor from '@/components/table/cell-editor/InputEditor';
import WSelectEditor from '@/components/table/cell-editor/SelectEditor';
import WCheckboxEditor from '@/components/table/cell-editor/CheckboxEditor';
import WSwitchEditor from '@/components/table/cell-editor/SwitchEditor';
import WNumberEditor from '@/components/table/cell-editor/NumberEditor';
import WHeaderPagination from '@/components/table/HeaderPagination';
import WGroupSaveButton from '@/views/settings/basic/DeviceRegistration/components/GroupSaveButton';
import WFacilityDeviceAddPopup from './popup/FacilityDeviceAddPopup';

const pagination = cloneDeep(defaultPagination);

export default {
  name: 'WDeviceRegist',
  components: {
    WFacilityDeviceAddPopup,
    WHeaderPagination,
    WInputEditor,
    WSelectEditor,
    WCheckboxEditor,
    WSwitchEditor,
    WNumberEditor,
    WGroupSaveButton,
  },
  mixins: [CellEditingMixin],
  data() {
    return {
      pagination,
      isLoading: false,
      total: null,
      columnDefault,
      showSearchTool: false,
      recentRegisteredFmsCount: 0,
      currentPage: 1,
      selectedRowArray: [],
      tableData: [],
      beforeThreeDayFlag: false,
      rtuList: [],
      snmpVersionList: [],
      rowRtuInfo: {},
      loadFromThreeDataFlag: false,
      tableColumn: [
        {
          // align: 'center',
          type: 'selection',
        },
        {
          prop: 'objManagementApplyFlag',
          label: '관리여부',
          editable: true,
          scopedSlot: 'switch-slot',
          width: 85,
          sortable: true,
          filters: [
            {
              text: '관리',
              value: '1',
            },
            {
              text: '비관리',
              value: '0',
            },
          ],
        },
        {
          prop: 'objName',
          label: '센서명',
          editable: true,
          scopedSlot: 'input-slot',
          minWidth: 150,
          searchable: true,
          sortable: true,
        },
        {
          prop: 'objtypeId',
          label: '센서종류',
          editable: true,
          scopedSlot: 'seonsor-type-slot',
          minWidth: 120,
          searchable: true,
        },
        {
          prop: 'parentObjName',
          label: '수집장비명',
          editable: true,
          scopedSlot: 'rtu-slot',
          minWidth: 140,
          searchable: true,
        },
        {
          prop: 'parentObjtypeId',
          label: '수집장비종류',
          formatter: this.formatParentObjtypeId,
          searchable: true,
          width: 95,
        },
        {
          prop: 'ipaddress',
          label: 'IP주소',
          editable: true,
          scopedSlot: 'ipaddress-slot',
          minWidth: 120,
          searchable: true,
          sortable: true,
        },
        {
          prop: 'alivecheckTcpPort',
          label: 'TCP 포트',
          editable: true,
          scopedSlot: 'tcp-port-slot',
          searchable: true,
          width: 65,
        },
        {
          prop: 'snmpVersion',
          label: 'SNMP 버전',
          editable: true,
          scopedSlot: 'snmp-version-slot',
          searchable: true,
          width: 105,
        },
        {
          prop: 'snmpCommunityRead',
          label: 'SNMP 커뮤니티',
          editable: true,
          scopedSlot: 'community-slot',
          width: 105,
        },
        {
          prop: 'snmpPort',
          label: 'SNMP 포트',
          editable: true,
          scopedSlot: 'snmp-port-slot',
          searchable: true,
          width: 65,
        },
        {
          prop: 'eventSetStatus',
          label: '이벤트 제외',
          editable: true,
          scopedSlot: 'checkbox-slot',
          align: 'center',
          width: 72,
        },
        {
          prop: 'rscEventRuleId',
          label: '수집/판단정책',
          editable: true,
          scopedSlot: 'rsc-rule-slot',
          minWidth: 120,
          searchable: true,
          remoteProp: 'rscrt.rule_tmpl_name',
        },
        {
          prop: 'eventAlarmRuleId',
          label: '이벤트/알림정책',
          editable: true,
          scopedSlot: 'event-rule-slot',
          minWidth: 120,
          searchable: true,
          remoteProp: 'eventrt.rule_tmpl_name',
        },
        {
          prop: 'registDatetime',
          label: '장비등록일시',
          searchable: true,
          searchType: 'date',
          formatter: this.getDateFormatter,
          width: 130,
          sortable: true,
        },
      ],
      rscEventRuleList: [], // 수집판단 정책 리스트
      eventAlarmRuleList: [], // 알람 정책 리스트
    };
  },
  computed: {
    // 센서 종류
    sensorTypeList() {
      return this.$store.state.common.availableSensorList;
    },
  },
  mounted() {
    // 정책 api 호출
    rulApi.getRscEventRules().then((response) => {
      if (response.data.success) {
        this.rscEventRuleList = response.data.data;
      }
    });
    rulApi.getEventAlarmRulesByManagetypeId('FMS').then((response) => {
      if (response.data.success) {
        this.eventAlarmRuleList = response.data.data;
        this.loadData();
      }
    });

    // RTU 조회
    this.loadRtuList();

    // SNMP 버전
    BasicinfoSubAPI.getList('SNMPVER').then((response) => {
      this.snmpVersionList = response.data.data;
    });
  },
  methods: {
    loadData() {
      // selection 초기화
      const deviceTable = this.$refs.deviceTable;
      deviceTable.$children[0].clearSelection();
      this.selectedRowArray = []; // 선택한 row들 내역 초기화
      // 3일 이전 데이터 조회 체크박스 플래그 전달
      const tableParams = this.$refs.deviceTable.getParameter();
      const params = {
        beforeThreeDayFlag: this.beforeThreeDayFlag,
        ...tableParams,
      };
      // '최근 3일 이내 등록된 장비' 클릭 시 start 값이 기존 값으로 남아있는 문제 인지, 초기화 추가
      if (this.loadFromThreeDataFlag) {
        params.start = 0;
      }
      DeviceRegistrationFmsApi.getRecentRegisteredFmsCount().then((response) => {
        if (response.data.success) {
          this.recentRegisteredFmsCount = response.data.data;
        }
      });
      this.isLoading = true;
      this.loadFromThreeDataFlag = false;
      DeviceRegistrationFmsApi.getFacilityList(params)
        .then((response) => {
          if (response.data.success) {
            this.total = response.data.total;
            this.tableData = this.getEditableTableData(response.data.data, this.tableColumn);
            this.resetCellEditing();
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    /**
     * [테이블 페이징] 페이지 변경 핸들러
     * @author Ju
     * @param  {Object} pagination 페이지 정보 객체
     */
    handlerPaginationChange(_pagination) {
      this.pagination = _pagination;
    },
    /**
     * [헤더 페이징] 현재 페이지 변경 핸들러
     * @author Ju
     * @param  {Number} currentPage 현재 페이지 번호
     */
    handlerHeaderCurrentChange(_currentPage) {
      this.$refs.deviceTable.setCurrentPage(_currentPage);
    },
    onChangeTable() {
      this.loadData();
    },
    setSearchToolVisible() {
      this.showSearchTool = !this.showSearchTool;
    },
    onSaveButton() {
      const updatedData = this.getUpdatedDatas(this.tableData, true, ['objId', 'parentObjId', 'parentObjtypeId', 'objCompanyId']);
      let ipDuplicatedFlag = false;
      const ipList = [];
      updatedData.forEach((obj) => {
        const ipaddress = obj.ipaddress;
        if (ipList.includes(ipaddress)) {
          ipDuplicatedFlag = true;
        }
        ipList.push(ipaddress);
        if (validateIpv4(ipaddress)) {
          obj.ipaddressApplytype = 'IPv4';
          obj.ipaddressIpv4 = ipaddress;
        } else {
          obj.ipaddressApplytype = 'IPv6';
          obj.ipaddressIpv6 = ipaddress;
        }
      });

      if (ipDuplicatedFlag) {
        this.$message(msgUtil.getCustomResultMsgData('중복된 IP가 존재합니다.', false));
        return;
      }

      // 수정 저장 시 eventSetStatus 대상 값이 1일경우는 event_set테이블에 대상 값이 추가될 것이고 0일 경우 삭제된다.
      const target = '관리 대상';
      const action = msgUtil.action.SAVE;
      getRsaEncryptBulk(updatedData, ['snmpCommunityRead'])
        .then((encryptDatas) => {
          DeviceRegistrationFmsApi.updateFacilityList(encryptDatas)
            .then((response) => {
              const result = response.data;
              if (result.success) {
                this.loadData();
              }
              this.$message(msgUtil.getResultMsgData(action, target, result.success));
            })
            .catch(() => {
              this.$message(msgUtil.getResultMsgData(action, target, false));
            });
        })
        .catch((e) => {
          this.$message(msgUtil.getResultMsgData(action, target, false));
          throw new Error(e);
        });
    },
    // 테이블 체크박스 셀렉션 change함수
    changeHandleSelection(selectVal) {
      this.selectedRowArray = selectVal;
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    getEmptyText(row, column, value) {
      if (value !== 'NONE' && !isEmpty(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    // 해당 장비들을 삭제한다.
    onDelDevice() {
      const target = '관리 대상';
      const action = msgUtil.action.DELETE;
      this.$confirm(...msgUtil.getBasicConfirmData(action)).then(() => {
        DeviceRegistrationFmsApi.deleteFacilityList(this.selectedRowArray)
          .then((response) => {
            const result = response.data;
            if (result.success) {
              this.loadData();
            }
            this.$message(msgUtil.getResultMsgData(action, target, result.success));
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
      });
    },
    // 수동 등록 버튼 이벤트
    onRegistDeviceButton() {
      this.$refs.facilityAddPop.open();
    },
    // objtypeId - FACILITY / RTU에 관한 것으로 추후 변경 시 수정필요
    formatParentObjtypeId(row, column, value) {
      if (value === 'FACILITY') {
        return '자체 수집';
      } else if (value === 'RTU') {
        return value;
      }
      return EMPTY_TEXT;
    },
    portEmptyText(row, column, value) {
      if (!isNil(value)) {
        return value;
      }
      return EMPTY_TEXT;
    },
    AllCheckChangeButtonClick(objManagementApplyFlag) {
      const result = this.editDirectBulk(this.tableData, 'objManagementApplyFlag', objManagementApplyFlag);
      this.tableData = result.tableData;
      this.completeEditBulk(...result);
    },
    /**
     * SNMP 커뮤니티 convert method
     * @param  {[type]} record [description]
     * @return {[type]}        [description]
     * @author jda
     */
    convertCommunityRead(record) {
      const snmpVersion = record.snmpVersion;
      if (!isNil(snmpVersion) && snmpVersion !== 'NONE' && snmpVersion !== 'V3') {
        return PASSWORD_FOR_VIEW;
      }
      return EMPTY_TEXT;
    },
    /**
     * ip주소 유효성검사
     * @param  {[type]} value [description]
     * @return {[type]}       [description]
     * @author jda
     */
    validateIpaddress(value) {
      return validateIpv4(value) || validateIpv6(value);
    },
    /**
     * 1. RTU 변경시 IP주소 자동 바인딩
     * 2. 자체수집인 센서는 수집 장비명 동일하게 표현
     * @param  {[type]} data     [description]
     * @param  {[type]} property [description]
     * @param  {[type]} dirty    [description]
     * @return {[type]}          [description]
     * @author jda
     */
    handlerEndEdit(data, property) {
      if (property === 'parentObjName' && data.parentObjtypeId === 'RTU') {
        this.editDirect(data, 'snmpPort', this.rowRtuInfo.snmpPort);
        this.rowRtuInfo = {};
      } else if (property === 'objName') {
        this.editDirect(data, 'parentObjName', data.objName);
      }
      this.checkExistModifiedData(this.tableData);
    },
    endIpaddressEdit(newValue) {
      const data = this.cellEditing.data;
      const property = this.cellEditing.property;

      if (data && property) {
        // TODO: Ediotr의 keyup 이벤트로 endEdit가 호출되는 경우, keyup 이벤트에 endEdit 한번 호출,
        // blur 이벤트에서 한번 호출 총 2번 호출이 가서 2번째에서 editing 객체가 초기화되어 에러남.
        // 일단  data와 property가 있을 경우만 하단의 로직 수행하도록 처리함.

        // ipValidation check
        let dirty = isEqual(this.cellEditing.originalValue, newValue);
        if (!dirty) {
          const params = {
            objManagetypeId: 'FMS',
            ipaddressApplytype: data.ipaddressApplytype,
          };
          if (validateIpv4(newValue)) {
            params.ipaddressIpv4 = newValue;
          } else if (validateIpv6(newValue)) {
            params.ipaddressIpv6 = newValue;
          }
          if (this.validateIpaddress(newValue)) {
            DeviceRegistrationCommonAPI.checkIpaddressValidation(params)
              .then((response) => {
                if (response.data.data) {
                  dirty = this.setModified(data, property, this.cellEditing.originalValue, newValue);
                } else {
                  dirty = this.setModified(data, property, this.cellEditing.originalValue, this.cellEditing.originalValue);
                }
              })
              .catch(() => {})
              .finally(() => {
                this.completeEdit(data, property, dirty);
              });
          }
        } else {
          dirty = this.setModified(data, property, this.cellEditing.originalValue, newValue);
          this.completeEdit(data, property, dirty);
        }
      }
    },
    /**
     * RTU 장비 조회
     * @return {[type]} [description]
     * @author jda
     */
    loadRtuList() {
      DeviceRegistrationFmsApi.getRtuList({}).then((response) => {
        if (response.data.success) {
          this.rtuList = response.data.data;
        } else {
          this.rtuList = [];
        }
      });
    },
    /**
     * RTU장비 변경시 ip주소, 포트 셋팅
     * @param  {[type]} objId [description]
     * @return {[type]}       [description]
     * @author jda
     */
    rtuEndEdit(objId) {
      const rtuInfo = find(this.rtuList, {
        objId,
      });
      this.rowRtuInfo = rtuInfo;
      this.endEdit(rtuInfo.objName);
    },
    onChangeThreeFlag() {
      this.loadFromThreeDataFlag = true;
      this.$nextTick(() => {
        this.$refs.deviceTable.setCurrentPage(1);
      });
    },
    groupSave(data) {
      if (!isEmpty(data)) {
        const checkedRows = cloneDeep(this.selectedRowArray);
        const updatedData = checkedRows.map((item) =>
          Object.assign(
            {},
            {
              objId: item.objId,
            },
            data,
          ),
        );
        const target = '관리 대상';
        const action = msgUtil.action.SAVE;
        DeviceRegistrationFmsApi.updateFacilityList(updatedData)
          .then((response) => {
            const result = response.data;
            if (result.success) {
              this.loadData();
            }
            this.$message(msgUtil.getResultMsgData(action, target, result.success));
          })
          .catch(() => {
            this.$message(msgUtil.getResultMsgData(action, target, false));
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/basic/DeviceRegistration/FacilityDevice/DeviceRegist.vue